import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { LightLocationModel, LightsActionsUnion, LightsActionTypes } from './lights.actions';

export const inRoomLightFeatureKey = 'inroom-light';

export type LightState = EntityState<LightLocationModel>;

export function selectLightIdFromLight(light: LightLocationModel) {
  return selectLightId(light.HotelCode ?? '', light.Room ?? '', light.Code ?? '');
}

export function selectLightId(hotelCode: string, room: string, code: string) {
  return hotelCode + '-' + room + '-' + code;
}

export const adapter: EntityAdapter<LightLocationModel> = createEntityAdapter<LightLocationModel>({
  selectId: selectLightIdFromLight,
});

export const initialState: LightState = adapter.getInitialState();

export function lightReducer(state: LightState = initialState, action: LightsActionsUnion) {
  switch (action.type) {
    case LightsActionTypes.LOAD_LIGHTS:
      return adapter.addMany(action.payload, state);
    case LightsActionTypes.UPDATE_LIGHTS:
      // TODO: Change to upsert. (Upsert goes wrong now, because of the ID)
      return adapter.updateOne(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectLightIds = selectIds;

export const selectLightEntities = selectEntities;

export const selectAllLights = selectAll;

export const selectLightsTotal = selectTotal;
